import { Stack, Button } from '@chakra-ui/react'
import FormField from '@/components/FormField'

interface RegisterChildFormProps {
    onSubmit: (data: any) => Promise<void>
    register: any
    errors: any
    isSubmitting: boolean
}

export default function RegisterChildForm({
    onSubmit,
    register,
    errors,
    isSubmitting
}: RegisterChildFormProps) {
    return (
        <form onSubmit={onSubmit}>
            <Stack spacing={4}>
                <FormField
                    label="First Name"
                    name="firstName"
                    type="text"
                    required
                    register={register}
                    error={errors.firstName}
                />
                <FormField
                    label="Middle Name"
                    name="middleName"
                    type="text"
                    register={register}
                    error={errors.middleName}
                />
                <FormField
                    label="Last Name"
                    name="lastName"
                    type="text"
                    required
                    register={register}
                    error={errors.lastName}
                />
                <FormField
                    label="Date of Birth"
                    name="dateOfBirth"
                    type="date"
                    required
                    register={register}
                    error={errors.dateOfBirth}
                />
                <FormField
                    label="Child's Photo"
                    name="picture"
                    accept="image/*"
                    type="file"
                    required
                    register={register}
                    error={errors.picture}
                    helperText="Maximum image size allowed is 4MB 😉"
                />
                <FormField
                    label="Gender"
                    name="gender"
                    type="select"
                    required
                    register={register}
                    error={errors.gender}
                >
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                </FormField>
                <FormField
                    label="Blood Group"
                    name="bloodGroup"
                    type="select"
                    register={register}
                    error={errors.bloodGroup}
                >
                    {['A +', 'A -', 'B +', 'B -', 'O +', 'O -', 'AB +', 'AB -'].map(
                        (group) => (
                            <option key={group} value={group}>
                                {group}
                            </option>
                        )
                    )}
                </FormField>
                <FormField
                    label="Allergies"
                    name="allergies"
                    type="text"
                    required
                    register={register}
                    error={errors.allergies}
                />
                <Button
                    mt={4}
                    type="submit"
                    size="lg"
                    isLoading={isSubmitting}
                    loadingText="Submitting"
                >
                    Submit
                </Button>
            </Stack>
        </form>
    )
}
